import { ROUTE_DASHBOARD } from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import {
	useCreateResourceGroupMutation,
	useRemoveResourceGroupMutation,
	useResourceGroupsDetailsQuery,
} from '@/queries/resourceGroups.queries';
import IResourceGroup from '@/types/IResourceGroup';
import { useDisclosure, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
export function useAvailabilityGroupDetailsPage() {
	const history = useHistory();
	const removeGroupMutation = useRemoveResourceGroupMutation();
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();
	const toast = useToast();
	const auth = useAuth();
	const disclosure = useDisclosure();
	const updateGroupMutation = useCreateResourceGroupMutation();
	const query = useResourceGroupsDetailsQuery({ id });

	function handleDeleteClick(id: string, resourceGroup: IResourceGroup) {
		updateGroupMutation
			.mutateAsync({ ...resourceGroup, resources: resourceGroup.resources.filter((r) => r.id !== id) })
			.then(() => {
				toast({
					title: t('Success'),
					status: 'success',
					duration: 3000,
					isClosable: true,
				});
			})
			.catch(() => {
				toast({
					title: t('Error'),
					status: 'error',
					duration: 3000,
					isClosable: true,
				});
			});
	}

	function handleNameBlur(name: string, resourceGroup: IResourceGroup) {
		return updateGroupMutation
			.mutateAsync({ ...resourceGroup, name })
			.then(() => {
				toast({
					title: t('Success'),
					status: 'success',
					duration: 3000,
					isClosable: true,
				});
			})
			.catch(() => {
				toast({
					title: t('Error'),
					status: 'error',
					duration: 3000,
					isClosable: true,
				});
			});
	}

	function handleRemoveClick() {
		return removeGroupMutation
			.mutateAsync({
				id,
			})
			.then(() => {
				toast({
					title: t('Success'),
					status: 'success',
					duration: 3000,
					isClosable: true,
				});
				history.push(ROUTE_DASHBOARD);
			})
			.catch(() => {
				toast({
					title: t('Error'),
					status: 'error',
					duration: 3000,
					isClosable: true,
				});
			});
	}

	return {
		handleRemoveClick,
		handleNameBlur,
		handleDeleteClick,
		id,
		disclosure,
		auth,
		t,
		query,
		goBack: () => history.goBack(),
	};
}
